export const SET_LOADING = 'root/SET_LOADING';
export const SET_ERROR = 'root/SET_ERROR';
export const SET_COMPANIES = 'root/SET_COMPANIES';
export const SET_INDUSTRIES = 'root/SET_INDUSTRIES';

export const SET_TASKS = 'task/SET_TASKS';
export const SET_TASK_DETAIL = 'task/SET_TASK_DETAIL';
export const SET_TRACKING = 'task/SET_TRACKING';

export const SET_BALANCE_SHEETS = 'balance-sheet/SET_BALANCE_SHEETS';
export const SET_BALANCE_SHEET_DETAIL = 'balance-sheet/SET_BALANCE_SHEET_DETAIL';

export const SET_PROFITS = 'profit/SET_PROFITS';
export const SET_PROFIT_DETAIL = 'profit/SET_PROFIT_DETAIL';

export const SET_CASHFLOWS = 'cashflow/SET_CASHFLOWS';
export const SET_CASHFLOW_DETAIL = 'cashflow/SET_CASHFLOW_DETAIL';

export const SET_CONTRACTS = 'contract/SET_CONTRACTS';
export const SET_CONTRACT_DETAIL = 'contract/SET_CONTRACT_DETAIL';
export const SET_CONTRACT_TYPES = 'contract/SET_CONTRACT_TYPES';

export const SET_RECEIPT_COUNTS = 'receipt-count/SET_RECEIPT_COUNTS';

export const SET_COMPANY_INFO = 'company/SET_COMPANY_INFO';

export const SET_TAX_FILINGS = 'tax-filing/SET_TAX_FILINGS';
export const SET_TAX_FILING_DETAIL = 'tax-filing/SET_TAX_FILING_DETAIL';

export const SET_BALANCES = 'balances/SET_BALANCES';